module.exports = __webpack_public_path__ + "static/jewelbotspair-830a5f6633424cd4704dab9b78431768.jpg";